import githubIcon from "../img/Icons/GithubIcon.png";

export default function Github(){
    return (
        <div className="linkTile">
            <a href="https://github.com/Milqz" target="_blank" rel="noopener noreferrer">
                <img src={githubIcon} alt="csharp"/>
            </a>
        </div>
    )
}